import { createContext, useContext, useState, useCallback } from 'react'

const ConfirmContext = createContext(null)

export function useConfirm() {
    return useContext(ConfirmContext)
}

export function ConfirmProvider({ children }) {
    const [state, setState] = useState(null)

    const confirm = useCallback((msg, opts = {}) => {
        return new Promise((resolve) => {
            setState({
                msg,
                title: opts.title || 'Konfirmasi',
                icon: opts.icon || '🗑️',
                confirmLabel: opts.confirmLabel || 'Hapus',
                confirmVariant: opts.confirmVariant || 'danger',
                resolve,
            })
        })
    }, [])

    const handleClose = (result) => {
        state?.resolve(result)
        setState(null)
    }

    return (
        <ConfirmContext.Provider value={confirm}>
            {children}
            {state && (
                <div className="confirm-overlay" onClick={() => handleClose(false)}>
                    <div className="confirm-box" onClick={(e) => e.stopPropagation()}>
                        <div className="confirm-icon">{state.icon}</div>
                        <div className="confirm-title">{state.title}</div>
                        <div className="confirm-msg">{state.msg}</div>
                        <div className="confirm-actions">
                            <button className="btn btn-secondary btn-sm" onClick={() => handleClose(false)}>
                                Batal
                            </button>
                            <button
                                className={`btn btn-${state.confirmVariant} btn-sm`}
                                onClick={() => handleClose(true)}
                            >
                                {state.confirmLabel}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </ConfirmContext.Provider>
    )
}
